<template>
	<div class="pull-dialog-body">
		<div class="pull-container">
			<div class="header-part">
				批量设置商品状态（已选择商品<span style="color:red">{{ids.length}}</span> 个）
			</div>
			<div class="container-box">
				<div style="height:40px;line-height:40px">
					<el-checkbox v-model="updateSaleStateFlag">可售状态：</el-checkbox>
					<el-radio :disabled='!updateSaleStateFlag' v-model="saleState" :label="1">可售</el-radio>
					<el-radio :disabled='!updateSaleStateFlag' v-model="saleState" :label="0">不可售</el-radio>
				</div>
				<div style="height:40px;line-height:40px">
					<el-checkbox v-model="updateHiddenFlag"> 私密状态：</el-checkbox>
					<el-radio :disabled='!updateHiddenFlag' v-model="hiddenFlag" :label="1">私密</el-radio>
					<el-radio :disabled='!updateHiddenFlag' v-model="hiddenFlag" :label="0">公开</el-radio>
				</div>
			</div>
			<div class="btn-box">
				<el-button class="btn" plain type="primary" @click="close">取 消</el-button>
				<el-button class="btn" plain type="primary" @click="save" >保 存</el-button>
			</div>
		</div>
		<span @click="close" class="close"><i class="el-icon-close"/>
		</span>
	</div>
</template>
<script>
export default {
	name: 'pullDialog',
	props: {
		ids: {
			type: Array,
			default: () => []
		},
		show: {
			type: Boolean
		}
	},
	watch: {
		show: {
			handler (val) {
				if (val) {
					this.updateSaleStateFlag = true
					this.updateHiddenFlag = true
					this.saleState = 1
					this.hiddenFlag = 1
				}
			},
			immediate: true
		}
	},
	data () {
		return {
			updateSaleStateFlag: true,
			updateHiddenFlag: true,
			hiddenFlag: 1,
			saleState: 1
		}
	},
	created () {

	},
	methods: {
		close () {
			this.$emit('close')
		},
		save () {
			let params = {
				ids: this.ids.join(','),
				updateSaleStateFlag: this.updateSaleStateFlag ? 1 : 0,
				saleState: this.saleState,
				updateHiddenFlag: this.updateHiddenFlag ? 1 : 0,
				hiddenFlag: this.hiddenFlag
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/goods/privateAndSale/update`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success('保存成功')
					this.$emit('reload')
					this.close()
				} else {
					this.$message.error(res.msg)
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.pull-dialog-body {
	height: 180px;
	padding-top: 10px;
	.pull-container {
		height: 100%;
		.header-part{
			width :100%;
			height :40px;
			text-align:left;
			font-size: 18px;
			color: #303133;
			font-weight :500
		}
		.container-box{
			text-align :left;
			width :100%;
			height :90px
			.el-checkbox{
				margin-right:0px !important;
			}
		}
		.btn-box {
			height: 40px;
			.el-button {
				width: 80px;
			}
		}
	}
	.close {
		position absolute
		right: 20px;
		top: 20px;
		cursor pointer
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background-color: red;
		line-height: 21px;
		font-weight: bold;
		.el-icon-close{
			color:#fff
		}
	}
}
</style>
<style lang="stylus">
.confirm-dialog {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
	}
	.el-dialog__headerbtn{
		width: 20px;
		height: 20px;
		border-radius: 50%;
		background-color: red;
		line-height: 20px;
		font-weight:blod;
		.el-icon-close{
			color:#fff
		}
	}
	.confirm-info {
		margin-top 10px
		width: 100%;
		height: 200px;
		border: 1px solid #ECECEC
		line-height 30px
		overflow-y auto
		.info-item {
			height: 30px
			border-bottom: 1px solid #ECECEC
			span {
				display inline-block
				width: 50%
				height: 100%
				padding-left 5px;
				box-sizing border-box
				&:first-child {
					border-right: 1px solid #ECECEC
					padding-right: 5px;
				}
			}
		}
	}
	.btn-box {
		margin-top 15px;
		display flex
		justify-content center
		.btn {
			width: 120px;
		}
	}
}
</style>
